import { resolveUpdatedAt } from './gqlMapUtils'

/** Map one wwwDebtConsolidationStatesCities item → REST parseEntry slim shape. */
function mapGeoCityItem(item) {
  if (!item) {
    return null
  }

  const pageUpdatedAt =
    item.linkedFrom?.wwwPagesCollection?.items?.[0]?.updatedAt ?? null

  return {
    state: item.state ?? null,
    city: item.city ?? null,
    slug: item.slug ?? null,
    contentType: 'wwwDebtConsolidationStatesCities',
    key: item.sys?.id ?? null,
    updatedAt: resolveUpdatedAt({ updatedAt: pageUpdatedAt, sys: item.sys }),
  }
}

/**
 * Map wwwDebtConsolidationStatesCitiesCollection → DebtConsolidationStatesCitiesRepository.fillCities cities/state slice.
 * @param {Array<object>} items
 * @returns {{ state: object | null, cities: object[] }}
 */
export function mapGeoCitiesGql(items = []) {
  const mapped = items.map(mapGeoCityItem).filter(Boolean)
  const stateEntry = mapped.find((entry) => !entry.city) ?? null
  const cities = mapped.filter((entry) => entry.city)

  return { state: stateEntry, cities }
}
